import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  sendNewPassword,
  sendResetPassword,
} from "../../helpers/backend_helper";

export const forgetUserThunk = createAsyncThunk<
  undefined,
  string,
  { rejectValue: Error }
>("authUser/forgetUserThunk", async (payload, { rejectWithValue }) => {
  try {
    await sendResetPassword(payload);
  } catch (error) {
    const { data } = error as {
      data: Error;
    };
    return rejectWithValue({ ...data });
  }
});

export const sendNewResetPasswordThunk = createAsyncThunk<
  undefined,
  {
    token: string;
    newPassword: string;
  },
  { rejectValue: Error }
>(
  "authUser/sendNewResetPasswordThunk",
  async (payload, { rejectWithValue }) => {
    try {
      await sendNewPassword(payload);
    } catch (error) {
      const { data } = error as {
        data: Error;
      };
      return rejectWithValue({ ...data });
    }
  }
);
